export { Details } from './Details'
